// extracted by mini-css-extract-plugin
module.exports = {"header":"header__header___1xbjs"};